import React, { Suspense, lazy } from 'react';

/**
 * STAGERY-93 — lazy import of RevenueDonut so the recharts dependency
 * (~290 kB / 90 kB gzipped, mostly d3) only ships when the admin Overview or
 * Revenue tab is actually opened. Without this it sits in the main vendor
 * chunk and inflates the cold-start payload for every authenticated user.
 */
const RevenueDonutInner = lazy(() =>
  import('./RevenueDonut').then((m) => ({ default: m.RevenueDonut })),
);

interface PlanMixEntry { plan: string; count: number; cents: number }
interface PlanArpuEntry { plan: string; arpu_cents: number }

interface Props {
  planMix: PlanMixEntry[];
  planArpu?: PlanArpuEntry[];
}

export const RevenueDonut: React.FC<Props> = (props) => (
  <Suspense fallback={<div className="h-[220px] w-full animate-pulse rounded-xl bg-black/[0.04] dark:bg-white/[0.04]" />}>
    <RevenueDonutInner {...props} />
  </Suspense>
);
